export function maskDigits(value, maxLength) {
  return String(value || '').replace(/\D/g, '').slice(0, maxLength);
}

export function formatPhone(value) {
  const digits = String(value || '').replace(/\D/g, '');
  let normalized = digits;
  if (normalized.startsWith('7') || normalized.startsWith('8')) {
    normalized = normalized.slice(1);
  }
  normalized = normalized.slice(0, 10);

  if (!normalized.length) return '';

  let result = '+7';
  if (normalized.length > 0) {
    result += ` (${normalized.slice(0, 3)}`;
  }
  if (normalized.length >= 3) {
    result += ')';
  }
  if (normalized.length > 3) {
    result += ` ${normalized.slice(3, 6)}`;
  }
  if (normalized.length > 6) {
    result += `-${normalized.slice(6, 8)}`;
  }
  if (normalized.length > 8) {
    result += `-${normalized.slice(8, 10)}`;
  }
  return result;
}

export function isValidEmail(value) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value || '').trim());
}

export function isValidPhone(value) {
  return /^\+7 \(\d{3}\) \d{3}-\d{2}-\d{2}$/.test(String(value || '').trim());
}

export function validateInvoiceForm(form) {
  const fieldErrors = {};
  const inn = maskDigits(form.inn, 12);
  const kpp = maskDigits(form.kpp, 9);
  const ogrn = maskDigits(form.ogrn, 15);
  const bankAccount = maskDigits(form.bankAccount, 20);
  const corrAccount = maskDigits(form.corrAccount, 20);
  const bik = maskDigits(form.bik, 9);

  if (!form.tariffId) {
    fieldErrors.tariffId = 'Выберите тариф';
  }
  if (!inn || (inn.length !== 10 && inn.length !== 12)) {
    fieldErrors.inn = 'ИНН: 10 цифр для организации или 12 для ИП';
  }
  if (kpp && kpp.length !== 9) {
    fieldErrors.kpp = 'КПП должен содержать 9 цифр';
  }
  if (ogrn && ogrn.length !== 13 && ogrn.length !== 15) {
    fieldErrors.ogrn = 'ОГРН: 13 цифр для организации или 15 для ИП';
  }
  if (!String(form.organizationName || '').trim()) {
    fieldErrors.organizationName = 'Укажите полное наименование организации';
  }
  if (!String(form.directorName || '').trim()) {
    fieldErrors.directorName = 'Укажите ФИО директора';
  }
  if (!String(form.legalAddress || '').trim()) {
    fieldErrors.legalAddress = 'Укажите юридический адрес';
  }
  if (!bankAccount || bankAccount.length !== 20) {
    fieldErrors.bankAccount = 'Расчётный счёт: 20 цифр';
  }
  if (!String(form.bankName || '').trim()) {
    fieldErrors.bankName = 'Укажите наименование банка';
  }
  if (!corrAccount || corrAccount.length !== 20) {
    fieldErrors.corrAccount = 'Корр. счёт: 20 цифр';
  }
  if (!bik || bik.length !== 9) {
    fieldErrors.bik = 'БИК: 9 цифр';
  }
  if (!String(form.phone || '').trim()) {
    fieldErrors.phone = 'Укажите телефон';
  } else if (!isValidPhone(form.phone)) {
    fieldErrors.phone = 'Телефон: формат +7 (XXX) XXX-XX-XX';
  }
  if (!String(form.email || '').trim()) {
    fieldErrors.email = 'Укажите email';
  } else if (!isValidEmail(form.email)) {
    fieldErrors.email = 'Неверный формат email';
  }

  return {
    fieldErrors,
    isValid: Object.keys(fieldErrors).length === 0,
  };
}

export function buildInvoicePayload(form) {
  return {
    tariffId: form.tariffId,
    inn: maskDigits(form.inn, 12),
    kpp: maskDigits(form.kpp, 9),
    ogrn: maskDigits(form.ogrn, 15),
    organizationName: String(form.organizationName || '').trim(),
    directorName: String(form.directorName || '').trim(),
    legalAddress: String(form.legalAddress || '').trim(),
    bankAccount: maskDigits(form.bankAccount, 20),
    bankName: String(form.bankName || '').trim(),
    corrAccount: maskDigits(form.corrAccount, 20),
    bik: maskDigits(form.bik, 9),
    phone: String(form.phone || '').trim(),
    email: String(form.email || '').trim(),
  };
}

export async function parseInvoiceApiError(error, defaultMessage = 'Не удалось сформировать счёт') {
  if (error.response?.data instanceof Blob) {
    try {
      const text = await error.response.data.text();
      const json = JSON.parse(text);
      const fieldErrors = {};

      if (Array.isArray(json.details)) {
        json.details.forEach((item) => {
          if (item.field && item.message) {
            fieldErrors[item.field] = item.message;
          }
        });
      }

      const messages = Object.values(fieldErrors);
      if (messages.length) {
        return {
          message: messages.join('. '),
          fieldErrors,
        };
      }

      if (json.message) {
        return { message: json.message, fieldErrors: {} };
      }
      if (json.error) {
        return { message: json.error, fieldErrors: {} };
      }
    } catch {
      return { message: defaultMessage, fieldErrors: {} };
    }
  }

  const data = error.response?.data;
  if (data?.details && Array.isArray(data.details)) {
    const fieldErrors = {};
    data.details.forEach((item) => {
      if (item.field && item.message) {
        fieldErrors[item.field] = item.message;
      }
    });
    const messages = Object.values(fieldErrors);
    if (messages.length) {
      return { message: messages.join('. '), fieldErrors };
    }
  }

  if (data?.message) {
    return { message: data.message, fieldErrors: {} };
  }
  if (data?.error) {
    return { message: data.error, fieldErrors: {} };
  }

  return { message: error.message || defaultMessage, fieldErrors: {} };
}
